export enum Role {
  VIEWER = 'viewer',
  OPERATOR = 'operator',
  TENANT_ADMIN = 'tenant-admin',
  SUPER_ADMIN = 'super-admin',
  // Papercast staff: cross-tenant read access (e.g. the full tenant list in
  // the switcher) without back-office admin rights.
  SUPPORT = 'support',
}
